export const otherIncomeTypes = [
  "Driver Bhatta",
  "Daily Permit",
  "Loading",
  "Unloading",
  "Parking",
  "Night Halt",
  "Cleaner Bhatta",
  "Union Charges",
  "Weight Charges",
];

export const locations = [
  "Mumbai",
  "Pune",
  "Nashik",
  "Aurangabad",
  "Nagpur",
  "Kolhapur",
  "Solapur",
  "Satara",
  "Sangli",
  "Ahmednagar",
  "Jalgaon",
  "Akola",
  "Delhi",
  "Jaipur",
  "Jodhpur",
  "Udaipur",
  "Ajmer",
  "Kota",
  "Bangalore",
  "Chennai",
  "Hyderabad",
  "Coimbatore",
  "Mysore",
  "Ahmedabad",
  "Surat",
  "Vadodara",
  "Rajkot",
  "Bhavnagar",
];
